import './index.scss';
import './print.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import posthog from 'posthog-js';

import Logger from '@KrashidBuilt/common/utils/logger';
import * as Sentry from '@sentry/react';
import { extraErrorDataIntegration } from '@sentry/integrations';

import App from './App';
import * as swr from './serviceWorkerRegistration';
import { ENVIRONMENT , POSTHOG_KEY } from './constants';
import pkg from '../package.json';


const logger = new Logger('index.js');

const BASENAME = '/app/speedlabel';

// redirect on url hash
const path = location?.hash ? location.hash.slice(1) : null;
if (path) {
    location.hash = ''; // reset
    history.replaceState({}, '', `${BASENAME}${path}`); // restore
}

if (ENVIRONMENT !== 'development') {
    Sentry.init({
        dsn: 'https://d2212de9f16f4edca0b1d78890176cad@o966616.ingest.sentry.io/5932795',
        integrations: [
            Sentry.browserTracingIntegration(),
            extraErrorDataIntegration({ depth: 11 }),
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
            })
        ],
        environment: ENVIRONMENT,
        release: pkg.version,
        tracesSampleRate: 1.0, // catch 100% of errors
        normalizeDepth: 11,
    });
}

swr.register({
    onSuccess: (registration) => {
        logger.info({ registration });
    },
    onUpdate: (registration) => {
        logger.info({ registration });

        const { caches } = window;

        if (caches) {
            caches.keys()
                .then((keys) => {
                    logger.info('Cache keys:', { keys });
                    for (let key of keys) {
                        logger.info('Removing cache:', key);
                        caches.delete(key);
                    }
                });
        }

        logger.info('Reloading app after cache clear.');
        window.location.reload(true);
    }
});

posthog.init(POSTHOG_KEY, {
    api_host: 'https://d19s1lpybdn7b1.cloudfront.net',
});

ReactDOM.render(<React.StrictMode>
    <App />
</React.StrictMode>, document.getElementById('root'));